import { phoneDigits } from '@/lib/clinic/format'

export interface TemplateValues {
    patientName: string
    clinicName: string
    doctorName: string
    followUpDate: string
    treatment: string
    clinicPhone: string
}

const TOKEN_KEYS: Record<string, keyof TemplateValues> = {
    'patient name': 'patientName',
    'clinic name': 'clinicName',
    'doctor name': 'doctorName',
    'follow-up date': 'followUpDate',
    'follow up date': 'followUpDate',
    treatment: 'treatment',
    'clinic phone': 'clinicPhone'
}

export const toWhatsAppNumber = (phone: string, countryCode: string): string | null => {
    const trimmed = phone.trim()
    let digits = phoneDigits(trimmed)

    if (!digits) return null
    if (trimmed.startsWith('+')) return digits
    if (digits.startsWith('00')) return digits.slice(2)
    if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1)

    const code = phoneDigits(countryCode)

    if (digits.length === 10 && code) return `${code}${digits}`

    return digits
}

export const buildWhatsAppUrl = (number: string, message: string): string => {
    return `https://wa.me/${number}?text=${encodeURIComponent(message)}`
}

export const fillTemplate = (body: string, values: TemplateValues): string => {
    return body.replace(/\[([^\]]+)\]/g, (match, token: string) => {
        const key = TOKEN_KEYS[token.trim().toLowerCase()]
        if (!key) return match

        return values[key] || match
    })
}
